import React, {useState} from 'react';
import {
    Banner,
    Modal, Spinner,
    TextContainer,
    TextField,
} from "@shopify/polaris";

import ConsignmentService from "../services/ConsignmentService";
import {getAxiosErrorMessage} from "../util/AxiosUtil";
import {isEmpty} from "../util/LangUtil";


type ConsignmentCancelModalProps = {
    visible: boolean,
    consignmentRefs: string[],
    onClose: () => void,
    onCancelComplete: () => void
}


export default function ConsignmentCancelModal({visible, consignmentRefs, onClose, onCancelComplete} : ConsignmentCancelModalProps) {

    const [reason, setReason] = useState("");
    const [cancelInProgress, setCancelInProgress] = useState(false);
    const [reasonFieldErrorMessage, setReasonFieldErrorMessage] = useState<string| undefined>(undefined);
    const [axiosErrorMessage, setAxiosErrorMessage ] = useState<string | null>(null);

    const buttonLabel = consignmentRefs.length === 1 ? "Cancel delivery" : `Cancel ${consignmentRefs.length} deliveries`;

    const onCloseClicked = () => {
        if (cancelInProgress) {
            return;
        }
        onClose();
    }

    const onCancelClicked = () => {
        if (cancelInProgress) {
            return;
        }
        if (isEmpty(reason)) {
            setReasonFieldErrorMessage("A reason is required");
            return;
        }
        setAxiosErrorMessage(null);
        setReasonFieldErrorMessage(undefined);
        setCancelInProgress(true);
        if (consignmentRefs.length === 1) {
            doCancelSingle();
        } else {
            doCancelMultiple();
        }
    }

    const doCancelSingle = () => {
        ConsignmentService.cancel(
            consignmentRefs[0],
            undefined,
            reason,
            onCancelComplete,
            axiosError => setAxiosErrorMessage(getAxiosErrorMessage(axiosError)),
            () => setCancelInProgress(false)
            );
    }

    const doCancelMultiple = () => {
        ConsignmentService.cancelMultiple(
            consignmentRefs,
            reason,
            onCancelComplete,
            axiosError => setAxiosErrorMessage(getAxiosErrorMessage(axiosError)),
            () => setCancelInProgress(false)
        );
    }

    return (
        <Modal
            open={visible}
            onClose={onCloseClicked}
            title={consignmentRefs.length === 1 ? "Cancel delivery?" : `Cancel ${consignmentRefs.length} deliveries?` }
            primaryAction={{
                content: buttonLabel,
                disabled: cancelInProgress,
                onAction: onCancelClicked,
            }}
        >
            <Modal.Section>
                {axiosErrorMessage &&
                <Banner
                    title="Error"
                    status="critical"
                >
                    <p>{axiosErrorMessage}</p>
                </Banner>
                }
                {cancelInProgress &&
                <div className="center-content">
                    <Spinner accessibilityLabel="Cancelling deliveries" size="large" />
                </div>}
                {!cancelInProgress &&
                <TextContainer>
                    <p>Cancelling deliveries requires a reason, please enter a reason below:</p>
                    <TextField
                        label="Reason"
                        labelHidden={true}
                        value={reason}
                        onChange={setReason}
                        multiline={4}
                        autoComplete="off"
                        autoFocus={true}
                        error={reasonFieldErrorMessage}
                    />
                </TextContainer>}
            </Modal.Section>
        </Modal>
    );

}